// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"401a4c8e","498":"95700fc2","598":"cf8d9629"}[chunkId] + ".chunk.js";
};